import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';

import React, { useEffect, useState } from 'react';

import { baseTheme } from '../../theme';

import LeaderWelcome from '../../components/leader-components/leader-welcome';
import LeaderFollowed from '../../components/leader-components/leader-followed';
import LeaderSearchResults from '../../components/leader-components/leader-search-results';
import { useDispatch, useSelector } from 'react-redux';
import { resetLeadersPage } from '../../store';
import { getMyLeaders } from '../../store/leaders/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
    },
    searchContainer: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(0),
    },
    searchResults: {
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0),
    },
    newSearchContent: {
      textAlign: 'center',
    },
  }),
);

export default function LeaderPage() {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const follow = useSelector((state: any) => state.leaders.follow);
  const currUser = useSelector((state: any) => state.auth.currUser);
  const [initPageLoad, setInitPageLoad] = useState(true);

  useEffect(() => {
    if (initPageLoad) {
      loadPage()
        .then(() => console.log('page loaded'));
    }
  }, [initPageLoad, currUser, dispatch]);

  const loadPage = async () => {
    dispatch(resetLeadersPage());
    await getMyLeaders(currUser.uid, dispatch);
  };

  const renderLeaderHeader = () => follow.length
    ? (<LeaderFollowed />)
    : (<LeaderWelcome />);
  return (
    <Grid item container direction="column" className={classes.root}>
      <Grid item container className={classes.searchContainer}>
        {renderLeaderHeader()}
      </Grid>
      <Grid item container className={classes.searchResults}>
        <LeaderSearchResults />
      </Grid>
    </Grid>
  );
}
